// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3221d138","839":"6e354789"}[chunkId] + ".chunk.js";
};